export const ONLINE_ORDERING_BASE_PATH = '/online-ordering';
export const DINE_IN_BASE_PATH = '/dine-in-ordering';
